export default "__VITE_ASSET__BaHL7KLi__"